import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const changePassword = (data) => (dispatch) => {
  return axioPath
    .post("/auth/reset_password", data)
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
